/// <reference path="DOMAttached.js" />

class FriendshipRequestButton extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.options = options;
		this.el = document.getElementById(el);
		this.acceptBtn = document.getElementById(this.options.acceptBtn);
		this.conReqLit = document.getElementById(this.options.conReqLit);
		this.responseMsg = document.getElementById(this.options.responseMessage);

		if (this.responseMsg) {
			this.responseMsg.style.display = 'none';
		}

		if (this.acceptBtn) {
			this.safeObserve(this.acceptBtn, 'click', this.onAccept.bind(this));
		}
	}

	onAccept(event) {
		event.preventDefault();
		event.stopPropagation();
		this.acceptBtn.style.display = 'none';
		this.responseMsg.style.display = '';
		axios(new UrlTemplate(this.options.acceptLink).url, {
			method: 'get'
		}).then(this.onResponse.bind(this));
	}

	onResponse(req) {
		var json = req.data;
		this.conReqLit.innerHTML = json.status;
		this.conReqLit.style.display = '';
	}
}
